var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentInprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5969 37.3006L60.5783 37.3098C58.3845 38.9922 57.455 41.8551 58.2359 44.5043L58.2451 44.5229C59.4906 48.7337 56.4047 52.9814 52.0173 53.0931H51.9988C49.2288 53.1674 46.7934 54.9334 45.8731 57.5454V57.5547C44.4044 61.7003 39.4038 63.3269 35.7879 60.8264C33.5426 59.2933 30.5745 59.2133 28.2122 60.8264H28.203C24.5872 63.3176 19.5864 61.7002 18.127 57.5453C17.1985 54.9268 14.7668 53.1672 12.0015 53.0929H11.9829C7.59562 52.9813 4.5095 48.7336 5.75513 44.5228L5.76437 44.5042C6.545 41.8549 5.6155 38.9921 3.422 37.3097L3.40337 37.3004C-0.082375 34.6233 -0.082375 29.3809 3.40337 26.7039L3.422 26.6947C5.6155 25.0123 6.545 22.1493 5.75513 19.5002V19.4816C4.50013 15.2709 7.5955 11.0229 11.9829 10.9114H12.0015C14.7621 10.8371 17.2068 9.07094 18.127 6.45906V6.44981C19.5863 2.30418 24.5872 0.67756 28.203 3.17806H28.2122C30.4895 4.74894 33.5011 4.74894 35.7879 3.17806C39.4401 0.655935 44.413 2.32906 45.8731 6.44981V6.45906C46.7934 9.06169 49.2286 10.8372 51.9988 10.9114H52.0173C56.4046 11.0229 59.4906 15.2709 58.2451 19.4816L58.2359 19.5002C57.455 22.1493 58.3845 25.0123 60.5783 26.6947L60.5969 26.7039C64.0826 29.3809 64.0826 34.6234 60.5969 37.3006Z",
    fill: "#FFA500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12858_34360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.334 43.7026C28.1735 43.4394 27.0589 43.0039 26.0273 42.4106",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.668 20.2974C37.3188 20.9028 39.6856 22.3903 41.3808 24.5163C43.076 26.6423 43.9992 29.2809 43.9992 32C43.9992 34.7192 43.076 37.3577 41.3808 39.4838C39.6856 41.6098 37.3188 43.0973 34.668 43.7027",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1048 38.7905C21.3774 37.7338 20.825 36.5668 20.4688 35.3345",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1641 30.0002C20.3774 28.7335 20.7881 27.5335 21.3641 26.4335L21.5894 26.0269",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2109 22.1054C26.4585 21.2466 27.858 20.633 29.3349 20.2974",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12858_34360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInprocess);
export default __webpack_public_path__ + "static/media/payment_inprocess.269bbc0b8d77b736452640f004185f9f.svg";
export { ForwardRef as ReactComponent };